// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorControllerInfoMessage, ElevatorControllerInfoMessageT } from './elevator-controller-info-message';
import { EscalatorControllerInfoMessage, EscalatorControllerInfoMessageT } from './escalator-controller-info-message';


export enum DeviceControllerInfoContent {
  NONE = 0,
  ElevatorControllerInfoMessage = 1,
  EscalatorControllerInfoMessage = 2
}

export function unionToDeviceControllerInfoContent(
  type: DeviceControllerInfoContent,
  accessor: (obj:ElevatorControllerInfoMessage|EscalatorControllerInfoMessage) => ElevatorControllerInfoMessage|EscalatorControllerInfoMessage|null
): ElevatorControllerInfoMessage|EscalatorControllerInfoMessage|null {
  switch(DeviceControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorControllerInfoMessage': return accessor(new ElevatorControllerInfoMessage())! as ElevatorControllerInfoMessage;
    case 'EscalatorControllerInfoMessage': return accessor(new EscalatorControllerInfoMessage())! as EscalatorControllerInfoMessage;
    default: return null;
  }
}

export function unionListToDeviceControllerInfoContent(
  type: DeviceControllerInfoContent, 
  accessor: (index: number, obj:ElevatorControllerInfoMessage|EscalatorControllerInfoMessage) => ElevatorControllerInfoMessage|EscalatorControllerInfoMessage|null, 
  index: number
): ElevatorControllerInfoMessage|EscalatorControllerInfoMessage|null {
  switch(DeviceControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorControllerInfoMessage': return accessor(index, new ElevatorControllerInfoMessage())! as ElevatorControllerInfoMessage;
    case 'EscalatorControllerInfoMessage': return accessor(index, new EscalatorControllerInfoMessage())! as EscalatorControllerInfoMessage;
    default: return null;
  }
}

export type DeviceControllerInfoContentT =
  | { type: 'NONE'; value: null }
  | { type: 'ElevatorControllerInfoMessage'; value: ElevatorControllerInfoMessageT }
  | { type: 'EscalatorControllerInfoMessage'; value: EscalatorControllerInfoMessageT };
